import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import locales from 'src/i18n/locales/en.json';

import { userDataKeys } from './constants';

export const useUtils = () => {
    const { watch, getValues } = useFormContext();
    const formData = watch();

    const [hasNationality, setHasNationality] = useState(false);
    const [spanishResidentRequired, setSpanishResidentRequired] = useState(false);

    const [nifRequired, setNifRequired] = useState(false);
    const [nieRequired, setNieRequired] = useState(false);
    const [passportRequired, setPassportRequired] = useState(false);

    const determineIfNationalitySelected = () => {
        const nationality = getValues(userDataKeys.nationality);

        setHasNationality(nationality && nationality.length);
    };

    const determineIfSpanishResidentRequired = () => {
        const nationality = getValues(userDataKeys.nationality);

        setSpanishResidentRequired(nationality && nationality !== locales.nationalities_spanish);
    };

    const determineIfPassportNumberRequired = () => {
        const nationality = getValues(userDataKeys.nationality);
        const isSpanishCitizen = nationality && nationality === locales.nationalities_spanish;
        const isSpanishResident = getValues(userDataKeys.isSpanishResident);

        setPassportRequired(!isSpanishCitizen && isSpanishResident === 'No');
    };

    const determineIfNifRequired = () => {
        const nationality = getValues(userDataKeys.nationality);
        setNifRequired(nationality && nationality === locales.nationalities_spanish);
    };

    const determineIfNieRequired = () => {
        const nationality = getValues(userDataKeys.nationality);
        const isSpanishCitizen = nationality && nationality === locales.nationalities_spanish;
        const isSpanishResident = getValues(userDataKeys.isSpanishResident);

        setNieRequired(!isSpanishCitizen && isSpanishResident === 'Yes');
    };

    useEffect(() => {
        determineIfNationalitySelected();
        determineIfSpanishResidentRequired();
        determineIfPassportNumberRequired();
        determineIfNifRequired();
        determineIfNieRequired();
    }, [formData]);
    return { hasNationality, spanishResidentRequired, nifRequired, nieRequired, passportRequired };
};
